import React, { useState, useRef, useEffect } from 'react';
import SearchIcon from '@mui/icons-material/Search';

function Filtro({ onFiltroChange }) {
    const [filtro, setFiltro] = useState('');
    const [isInputVisible, setIsInputVisible] = useState(false);
    const inputRef = useRef(null);

    const handleIconClick = () => {
        setIsInputVisible(true);
    };

    const handleChange = (event) => {
        const novoFiltro = event.target.value;
        setFiltro(novoFiltro);
        onFiltroChange(novoFiltro);
    };

    const handleInputBlur = () => {
        if (filtro.trim() === '') {
            setIsInputVisible(false);
        }
    };

    useEffect(() => {
        if (isInputVisible) {
            inputRef.current.focus();
        }
    }, [isInputVisible]);

    return (
        <div style={{  }}>
            {isInputVisible ? (
                <input
                    type="text"
                    value={filtro}
                    onChange={handleChange}
                    onBlur={handleInputBlur}
                    placeholder="Filtrar..."
                    ref={inputRef}
                    style={{
                        padding: '8px 30px',
                        borderRadius: '14px',
                        width: '200px',  // Ajuste o tamanho conforme necessário
                    }}
                />
            ) : (
                <span onClick={handleIconClick} style={{ cursor: 'pointer' }}>
                    <SearchIcon style={{ verticalAlign: 'middle', fontSize: 30 }} />
                </span>
            )}
        </div>
    );
}

export default Filtro;
